/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';

import DashboardContext from '../../Context';
import PropTypes from 'prop-types';

/**
 * این کامپوننت برای اینپوت های قابل سرچ دراپ دانی است
 */
export default function InputControlAsync({
  url,
  name,
  defaultValue,
  handelValue,
  label,
  idSelect,
  isActive,
  fromHcm = false,
}) {
  const { authentication, urldashboard, handelerrors, urlHcm } =
    useContext(DashboardContext);
  const [datadefult, setDatadefult] = useState({});

  const dataFeching = async (value) => {
    const params = { isActive: isActive };
    try {
      const res = await Axios.get(
        `${fromHcm ? urlHcm : urldashboard}${url}/${value}`,
        {
          params,
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res?.data;
      if (defaultValue) {
        setDatadefult(
          data?.data?.filter(
            (item) => item.value.toString() === idSelect.toString()
          )[0]
        );
      }
      return fromHcm
        ? data?.map((item) => {
            return {
              label: item?.value,
              value: item?.key,
            };
          })
        : data?.data;
    } catch (error) {
      handelerrors(error);
    }
  };

  const handeloncheng = (event) => {
    if (event) {
      handelValue(name, event.value);
    } else {
      handelValue(name, event);
    }
  };

  const handelloadOptions = (value) => {
    if (value.length > 2) {
      return dataFeching(value);
    }
  };

  useEffect(() => {
    if (defaultValue) {
      dataFeching(defaultValue);
    }
    return () => {};
  }, [defaultValue]);

  return (
    <Form.Group>
      {label ? <Form.Label>{label}</Form.Label> : null}
      {defaultValue !== undefined ? (
        datadefult?.hasOwnProperty('label') ? (
          <AsyncSelect
            className='basic-single'
            classNamePrefix='select'
            styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
            onChange={handeloncheng}
            defaultValue={datadefult}
            isRtl
            name={name}
            loadOptions={handelloadOptions}
            cacheOptions
            defaultOptions
          />
        ) : null
      ) : (
        <AsyncSelect
          className='basic-single'
          classNamePrefix='select'
          styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
          onChange={handeloncheng}
          isRtl
          isClearable
          name={name}
          loadOptions={handelloadOptions}
          cacheOptions
          defaultOptions
        />
      )}
    </Form.Group>
  );
}

InputControlAsync.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
  /**آدرس که برای دریافت داده استفاده می شود */
  url: PropTypes.string,
  /**ایدی چیزی است که باید انتخاب شود */
  idSelect: PropTypes.string,
};
